import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {Toaster} from 'sonner'
import Loader from '../components/Loader'
import './styles/auth.css'
import {defaultQueryClientOptions, setQueryClient} from '../lib/queryClient'

const queryClient = new QueryClient({defaultOptions: defaultQueryClientOptions})

export default function Auth() {
  useEffect(() => {
    setQueryClient(queryClient)
  }, [])
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position='top-center' />
      <div className='AuthContainer'>
        <div className='AuthContentContainer'>
          <Suspense fallback={<Loader variant='fullscreen' />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </QueryClientProvider>
  )
}
